import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Pane, SplitPane } from '@sierralabs/core-ui';
import SiteComponentsPanel from '../panels/SiteComponentsPanel';
import SiteConfigurePanel from '../panels/SiteConfigurePanel';
import SiteNavPanel from '../panels/SiteNavPanel';
import PreviewFrame from '../PreviewFrame';
import { useSiteContext } from '../SiteContext';
import { useParams } from 'react-router-dom';
import { StringParam, useQueryParam } from 'use-query-params';
const StyledDiv = styled.div `
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  .editor-container {
    flex: 1;
  }
  .config-pane,
  .navigation-pane {
    min-width: 240px;
  }
  .site-pane {
    overflow: hidden;
  }
  .route-component-pane {
    overflow: hidden;
  }
  .preview-frame {
    width: 100%;
    height: 100%;
  }
  .flex {
    flex: 1;
  }
`;
export const SiteEditor = () => {
    const { editPath, editorPath, siteComponentMap, configureComponent, setSelectedComponent, setEditPath, toggleEdit, findSite } = useSiteContext();
    const { siteId } = useParams();
    const [path, setPath] = useQueryParam('path', StringParam);
    const [componentId, setComponentId] = useQueryParam('componentId', StringParam);
    const lastPathRef = useRef();
    // initial load of site entity
    useEffect(() => {
        if (window.location.pathname.indexOf(editorPath) === 0) {
            // load site for editing
            siteId && findSite(siteId);
        }
    }, [siteId, editorPath, findSite]);
    // set the edit path from query string and notify site context of editing
    // state
    useEffect(() => {
        // TODO: update query string if editPath changes
        if (path && path !== editPath) {
            if (!lastPathRef.current || path !== lastPathRef.current) {
                setEditPath(path);
                lastPathRef.current = path;
            }
            else if (editPath) {
                setPath(editPath);
                lastPathRef.current = editPath;
            }
            toggleEdit(true);
        }
    }, [editPath, path, setEditPath, toggleEdit, setPath]);
    // update querystring of current component being edited
    useEffect(() => void ((configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.id) && setComponentId(configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.id)), [configureComponent === null || configureComponent === void 0 ? void 0 : configureComponent.id, setComponentId]);
    // initial load get configurable component
    useEffect(() => {
        if (componentId) {
            const component = siteComponentMap[componentId];
            if (component) {
                setSelectedComponent(component);
            }
        }
    }, [componentId, siteComponentMap, setSelectedComponent]);
    return (React.createElement(StyledDiv, { className: 'site-editor' },
        React.createElement(SplitPane, { className: 'editor-container' },
            React.createElement(SplitPane, { width: 240, className: 'navigation-pane' },
                React.createElement(SplitPane, { direction: 'vertical', className: 'route-component-container' },
                    React.createElement(SplitPane, { height: '30%', className: 'route-pane' },
                        React.createElement(SiteNavPanel, null)),
                    React.createElement(Pane, { className: 'route-component-pane' },
                        React.createElement(SiteComponentsPanel, null)))),
            React.createElement(SplitPane, { primary: 'next' },
                React.createElement(Pane, { className: 'site-pane' }, path && React.createElement(PreviewFrame, { className: 'preview-frame', path: path })),
                React.createElement(SplitPane, { width: 240, className: 'config-pane' },
                    React.createElement(SiteConfigurePanel, null))))));
};
export default SiteEditor;
//# sourceMappingURL=SiteEditor.js.map